export const MIN_SALES_DISPLAY_DURATION_SECONDS = 15;

export type SalesDisplaySlideKind = "message" | "image" | "video" | "widget";
export type SalesDisplayWidgetKey = "kpi" | "leaderboard" | "pipeline" | "hall_of_fame";

export interface SalesDisplaySlide {
  id: string;
  kind: SalesDisplaySlideKind;
  title: string;
  body: string | null;
  mediaPath: string | null;
  mediaUrl: string | null;
  widgetKey: SalesDisplayWidgetKey | null;
  durationSeconds: number;
  sortOrder: number;
  isActive: boolean;
}

export const DEFAULT_SALES_DISPLAY_SLIDES: SalesDisplaySlide[] = [
  ["kpi", "Måltall"],
  ["leaderboard", "Toppliste"],
  ["hall_of_fame", "Hall of Fame"],
].map(([widgetKey, title], index) => ({
  id: `default-${widgetKey}`,
  kind: "widget",
  title,
  body: null,
  mediaPath: null,
  mediaUrl: null,
  widgetKey: widgetKey as SalesDisplayWidgetKey,
  durationSeconds: MIN_SALES_DISPLAY_DURATION_SECONDS,
  sortOrder: (index + 1) * 10,
  isActive: true,
}));

export function normalizeSalesDisplayDuration(value: number): number {
  if (!Number.isFinite(value)) return MIN_SALES_DISPLAY_DURATION_SECONDS;
  return Math.max(MIN_SALES_DISPLAY_DURATION_SECONDS, Math.round(value));
}

export function activeSalesDisplaySlides(slides: SalesDisplaySlide[]): SalesDisplaySlide[] {
  return slides
    .filter((slide) => slide.isActive)
    .sort((a, b) => a.sortOrder - b.sortOrder || a.id.localeCompare(b.id));
}
